// extracted by css-extract-rspack-plugin
export default {"root":"root-ZMkf6Z","spin":"spin-nshIns","default":"default-X2Se7_","invert":"invert-xiz4pB","inherit":"inherit-Uc5yHf","svg":"svg-zQ4kSk"};